<template>
  <v-stepper v-model="currentElement">
    <v-stepper-header>
      <template v-for="(step, s) in steps">
        <div :key="s">
          <v-stepper-step :complete="currentElement > (s + 1)" :step="s + 1">Question {{ s + 1 }}</v-stepper-step>
          <v-divider v-if="s !== steps.length - 1"></v-divider>
        </div>
      </template>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content v-for="(step, s) in steps" :step="s + 1" :key="`content-${s + 1}`">
        
        <label>{{ step.title }}</label>
        <v-textarea rows="3" label="Your answer" class="py-3" @change="changeAIAnswer(s, $event)"></v-textarea>
        <v-btn
          color="primary"
          @click="currentElement = currentElement === steps.length ? 1 : (currentElement + 1)"
        >
          Next
        </v-btn>

      </v-stepper-content>
      <v-flex class="my-3 flex-end">
        <v-btn
          class="pf-btn-text-white pf-bg-pink"
          @click="$emit('cancel')"
          >
          Cancel
        </v-btn>
        <v-btn
          :disabled="!AIAnswers.filter(x => x && x.trim() && x.trim().length).length"
          class="pf-btn-text-white pf-bg-green"
          @click="submit"
        >
          Submit
        </v-btn>
      </v-flex>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
/* global session */

// This is to show the stepwise instructions to the user
export default {
  name: 'stepper-functions',
  components: {
  },
  props: {
    steps: {
      type: Array,
      default: [],
      required: true
    }
  },
  data: () => ({
    currentElement: 0,
    AIAnswers: []
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    this.steps.forEach(x => {
      this.AIAnswers.push('');
    });
  },
  methods: {
    changeAIAnswer (index, e) {
      if (e && e.trim()) {
        this.AIAnswers[index] = e.trim();
      }
    },
    submit () {
      this.$emit('submit', this.AIAnswers);
    }
  }
};
</script>
  
  
<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/components/StepperFunctions.vue